import { getConvertedExtension } from './getIconForFile';
import FolderSvg from 'owa-fluent-icons-svg/lib/icons/FolderRegular';
import GenericSvg from 'owa-fluent-icons-svg/lib/icons/DocumentFilled';
import { getFileTypeIconProps, initializeFileTypeIcons } from '@fluentui/react-file-type-icons';
import { isFeatureEnabled } from 'owa-feature-flags';

if (!isFeatureEnabled('cmp-layout-redesign')) {
    initializeFileTypeIcons();
}

export function getSvgIconForFile(fileName: string, isFolder: boolean = false, mimeType?: string) {
    if (isFolder) {
        return FolderSvg;
    }

    const convertedExtension: string | undefined = getConvertedExtension(fileName, mimeType);

    if (convertedExtension) {
        const fileIcon = {
            ...getFileTypeIconProps({
                extension: convertedExtension,
                size: 16,
                imageFileType: 'svg',
            }),
        };

        return fileIcon.iconName;
    }

    return GenericSvg;
}
